import { render, staticRenderFns } from "./BillingInfo.vue?vue&type=template&id=22c1f333&scoped=true"
import script from "./BillingInfo.vue?vue&type=script&lang=js"
export * from "./BillingInfo.vue?vue&type=script&lang=js"
import style0 from "./BillingInfo.vue?vue&type=style&index=0&id=22c1f333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1f333",
  null
  
)

export default component.exports